/*******************************************************************************
 * Initial state
 */
const initialState = {
    loading: false,
    error: ''
};

/*******************************************************************************
 * Non-async action types
 */
export const LOADING_START = 'loading/start';
export const LOADING_END   = 'loading/end';
export const SET_ALERT_MESSAGE   = 'state/setAlert';
export const CLEAR_ALERT_MESSAGE   = 'state/clearAlert';
export const SET_ERROR = 'state/setError';
export const CLEAR_ERROR = 'state/clearError';

/*******************************************************************************
 * Reducer
 */
export default function appReducer( state = initialState, action ) {
    switch ( action.type ) {
        case LOADING_START: {
            return {
                ...state,
                loading: true
            };
        }
        case LOADING_END: {
            return {
                ...state,
                loading: false
            };
        }
        case SET_ALERT_MESSAGE: {
            return {
                ...state,
                alertMessage: {
                    type: action.alertType,
                    text: action.data
                }
            };
        }
        case CLEAR_ALERT_MESSAGE: {
            return {
                ...state,
                alertMessage: {}
            };
        }
        case SET_ERROR: {
            return {
                ...state,
                error: action.data
            };
        }
        case CLEAR_ERROR: {
            return {
                ...state,
                error: []
            };
        }
        default:
            return state;
    }
}

/*******************************************************************************
 * Action creators
 */
export function startLoading( ) {
    return {
        type: LOADING_START
    };
}

export function endLoading( ) {
    return {
        type: LOADING_END
    };
}

export function setError( data ) {
    return {
        type: SET_ERROR,
        data
    };
}

export function clearError( ) {
    return {
        type: CLEAR_ERROR
    };
}

export function setAlertMessage( data, alertType ) {
    return {
        type: SET_ALERT_MESSAGE,
        alertType: alertType,
        data
    };
}

export function clearAlertMessage( ) {
    return {
        type: CLEAR_ALERT_MESSAGE
    };
}
